import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=f8f31d72&"
import script from "./CardContent.vue?vue&type=script&lang=js&"
export * from "./CardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports